import api from '@/api'
import jsCookie from 'js-cookie'
import { handleLogin, getUserInfo, smsLogin } from '@/api/base'
import { getExpressFeeList, getSupportExpress } from '@/api/shop'

const state = () => ({
    account: localStorage.account || '',
    token: localStorage.token || '',
    failure_time: localStorage.failure_time || '',
    permissions: [],
    userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
    channel: localStorage.channel || 'user',
    feeNum: 0, // 运费模板数量
    expressList: [] // 快递列表
})

const getters = {
    isLogin: state => {
        let retn = false
        if (state.token) {
            if (new Date().getTime() < state.failure_time * 1000) {
                retn = true
            }
        }
        return retn
    }
}

const actions = {
    login({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            handleLogin(data).then(async res => {
                commit('setUserData', {
                    account: data.phone,
                    token: res.data.token,
                    channel: 'user',
                    failure_time: Math.ceil(new Date().getTime() / 1000) + 24 * 60 * 60 // 一天过期时间
                })
                dispatch('getUserInfo')
                dispatch('getUserFeeNum')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    smsLogin({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            smsLogin(data).then(async res => {
                commit('setUserData', {
                    account: data.phone,
                    token: res.data.token,
                    channel: 'user',
                    failure_time: Math.ceil(new Date().getTime() / 1000) + 24 * 60 * 60 // 一天过期时间
                })
                dispatch('getUserInfo')
                dispatch('getUserFeeNum')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    logout({ commit }) {
        commit('removeUserData')
        commit('menu/invalidRoutes', null, { root: true })
    },
    getUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            getUserInfo({}).then(async res => {
                commit('setUserInfo', res)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    getUserFeeNum({ commit }) {
        return new Promise((resolve, reject) => {
            getExpressFeeList({ }).then(async res => {
                commit('setUserFeeNum', res.data?.length || 0)
                resolve(res.data?.length)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getExpressList({ commit }) {
        return new Promise((resolve, reject) => {
            getSupportExpress({ }).then(({ data = [] }) => {
                commit('setExpressList', data)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 获取我的权限
    getPermissions({ state, commit }) {
        return new Promise(resolve => {
            // 通过 mock 获取权限
            api.get('member/permission', {
                baseURL: '/mock/',
                params: {
                    account: state.account
                }
            }).then(res => {
                commit('setPermissions', res.data.permissions)
                resolve(res.data.permissions)
            })
        })
    }
}

const mutations = {
    setUserData(state, data) {
        localStorage.setItem('account', data.account)
        localStorage.setItem('token', data.token)
        localStorage.setItem('failure_time', data.failure_time)
        state.account = data.account
        state.token = data.token
        state.failure_time = data.failure_time

        localStorage.setItem('channel', data.channel)
        state.channel = data.channel
    },
    setUserInfo(state, { data = {} }) {
        state.userInfo = data || {}
        localStorage.setItem('userInfo', JSON.stringify(data))
    },
    editUserInfo(state, data) {
        state.userInfo = Object.assign(state.userInfo, data)

        localStorage.setItem('userInfo', JSON.stringify(state.userInfo))

        jsCookie.set('userInfo', JSON.stringify(state.userInfo), { domain: import.meta.env.VITE_APP_DOMAIN, expires: 7 })
    },
    removeUserData(state) {
        localStorage.removeItem('account')
        localStorage.removeItem('token')
        localStorage.removeItem('failure_time')
        localStorage.removeItem('userInfo')
        state.account = ''
        state.token = ''
        state.failure_time = ''
        state.userInfo = {}

        jsCookie.remove('token', { domain: import.meta.env.VITE_APP_DOMAIN })
        jsCookie.remove('userInfo', { domain: import.meta.env.VITE_APP_DOMAIN })
    },
    setPermissions(state, permissions) {
        state.permissions = permissions
    },
    setUserFeeNum(state, num) {
        state.feeNum = num
    },
    setExpressList(state, expressList) {
        state.expressList = expressList
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
